import type { StateCreator } from 'zustand'
import type { TypeLive } from '../../types/lives/live'
import type { ReturnForUser } from '../../types/lives/messages'

interface State {
  // live: Live | null
  liveId: number | null
  isStreamer: boolean
  myUserId: number | null
  typeLive: TypeLive | null
  liveCountry: string | null
  liveUserId: number | null
  token: string | null
  utc: string | null
  // liveClosedResume: Live | null
  livePoints: number
  pointsUsersLive: Record<string, ReturnForUser>
  // usersMutedForMe: number[]
  // usersSoundLevels: Record<string, number> | null
  coinsInLive: number
  // info: {
  //   isInSeat: boolean
  //   isAudioMuted: boolean
  //   isVideoMuted: boolean
  //   isSpeakerMuted: boolean
  // }
}

interface Actions {
  // changeInfo: (info: Partial<State['info']>) => void

  // setTotalPointsUserLive: (totalPoints: Record<string, ReturnForUser>) => void
  // updateUserLivePoints: (userId: number, points: number) => void
  setLivePoints: (points: number) => void
  // setPointsUserLive: (points: ReturnForUser) => void
  // clearPointsUserLive: () => void
  updateLivePoints: (points: number) => void

  // setLive: (live: Live) => void

  // addUserMutedForMe: (userId: number) => void
  // removeUserMutedForMe: (userId: number) => void
  // clearUserMutedForMe: () => void

  // clearLive: () => void

  // setUsersSoundLevels: (usersSoundLevels: Record<string, number>) => void
  // clearUsersSoundLevels: () => void
}

export type LiveSlice = State & Actions

export const liveStore: StateCreator<LiveSlice, [], [], LiveSlice> = (set) => ({
  // live: null,
  liveId: null,
  isStreamer: false,
  myUserId: null,
  typeLive: null,
  liveCountry: null,
  liveUserId: null,
  token: null,
  utc: null,
  livePoints: 0,
  // liveClosedResume: null,
  // liveSetting: null,
  // userLiveSetting: null,
  // appSetting: null,
  // usersSoundLevels: null,
  // livePoints: 0,
  coinsInLive: 0,
  // liveTitle: '',
  pointsUsersLive: {},
  // usersMutedForMe: [],
  // liveDetailPeople: [],
  // dataAdmins: [],
  // usersInLive: [],
  // info: {
  //   isInSeat: false,
  //   isAudioMuted: false,
  //   isVideoMuted: false,
  //   isSpeakerMuted: false,
  // },
  // changeInfo: (info) => {
  //   set((prevState) => ({
  //     info: { ...prevState.info, ...info },
  //   }))
  // },
  // setLive: (live) => {
  //   set({ live })
  // },
  setLivePoints: (points) => {
    set({ livePoints: points })
  },
  // setTotalPointsUserLive: (totalPoints) => {
  //   set({ pointsUsersLive: totalPoints })
  // },
  // setPointsUserLive: (points) => {
  //   set((prevState) => {
  //     const pointsArr = { ...prevState.pointsUsersLive }

  //     if (pointsArr[points?.userId]) {
  //       pointsArr[points?.userId].value += points.value
  //     } else {
  //       pointsArr[points?.userId] = points
  //     }

  //     return { pointsUsersLive: pointsArr }
  //   })
  // },
  // clearPointsUserLive: () => {
  //   set({ pointsUsersLive: {} })
  // },
  updateLivePoints: (points) => {
    set((prevState) => ({ livePoints: prevState?.livePoints + points }))
  },
  // clearLive: () => {
  //   set({ live: null })
  // },
  // updateUserLivePoints: (userId, points) => {
  //   set((prevState) => {
  //     const newObj = { ...prevState.pointsUsersLive }
  //     newObj[userId] = { userId, value: points }
  //     return { pointsUsersLive: newObj }
  //   })
  // },
  // addUserMutedForMe: (userId) => {
  //   set((prevState) => ({
  //     usersMutedForMe: prevState.usersMutedForMe.concat(userId),
  //   }))
  // },
  // removeUserMutedForMe: (userId) => {
  //   set((prevState) => ({
  //     usersMutedForMe: prevState.usersMutedForMe.filter((id) => id !== userId),
  //   }))
  // },
  // clearUserMutedForMe: () => {
  //   set({ usersMutedForMe: [] })
  // },
  // setUsersSoundLevels: (usersSoundLevels) => {
  //   set({ usersSoundLevels: usersSoundLevels })
  // },
  // clearUsersSoundLevels: () => {
  //   set({ usersSoundLevels: null })
  // },
})
